import { Component } from '@angular/core';

@Component({
  selector: 'rb-grid',
  template: `<ng-content></ng-content>`,
})
export class RBGridComponent {}
